import { render, staticRenderFns } from "./InstitutionSettingsDelivery.vue?vue&type=template&id=7f0f5f7e"
import script from "./InstitutionSettingsDelivery.vue?vue&type=script&lang=js"
export * from "./InstitutionSettingsDelivery.vue?vue&type=script&lang=js"
import style0 from "./InstitutionSettingsDelivery.vue?vue&type=style&index=0&id=7f0f5f7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports